import { FC } from 'react';
import s from './AttachFile.module.css';
import { useTranslation } from 'react-i18next';
import { formatFileSize } from 'lib/utils/common/formatFileSize';
import { Button } from 'components/common/Button';
import { ReactComponent as Remove } from 'images/cross.svg';

const icons = {
  remove: <Remove />,
};

type AttachFileProps = {
  name: string;
  onRemove: () => void;
  size: number;
};

export const AttachFile: FC<AttachFileProps> = ({ name, onRemove, size }) => {
  const { t } = useTranslation();
  const formattedSize = formatFileSize(size);

  return (
    <div className={s['attach-file']}>
      <span className={s['attach-file__name']}>{name}</span>

      <Button
        type='button'
        className={s['attach-file__remove']}
        onClick={onRemove}
        aria-label={`${t('common.remove')} ${name}`}
      >
        {icons.remove}
      </Button>

      <span className={s['attach-file__size']}>{formattedSize}</span>
    </div>
  );
};
